import React from "react";
import {
    Button,
    convertInputFormToObject,
    SelectField
} from "../../../../Components/Inputs";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {LinkButton} from "../../../../Components/Link";
import {locations} from "../../../../Utilities/Location";
import {isAphLoanFormValid} from "./aphQueueUtility";
import {isFimcAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";
import type {ListItem} from "../../../../Utilities/Types/listUtilities";

interface AphQueueFormProps {
    aphLoanForm: Record<string, any>;
    handleAssignAphQueueItems: (data: Record<string, unknown>) => void;
    setWarnings: (warnings: string[]) => void;
    shippingLocations: ListItem[];
    students: ListItem[];
}

export const AphQueueForm = ({
                                 aphLoanForm,
                                 handleAssignAphQueueItems,
                                 setWarnings,
                                 shippingLocations,
                                 students,
                             }: AphQueueFormProps) => {

    const handleClickSubmit = () => {

        if (!isFimcAdmin() && !isAphLoanFormValid(aphLoanForm)) {
            setWarnings(["Missing required items.  Please review your responses and try submitting again.",]);
            return;
        }

        const loanModel = convertInputFormToObject(aphLoanForm);
        handleAssignAphQueueItems(loanModel);
    }

    return <>
        <GridContainer hasMarginX>
            <SelectField
                {...aphLoanForm.shippingLocationId}
                defaultOption={`Select Shipping Location`}
                medium_columns={gridConstants.column.SIX}
                large_columns={gridConstants.column.SIX}
                label={`Location`}
                options={shippingLocations}
            />

            <SelectField
                {...aphLoanForm.studentId}
                defaultOption={`Select Student`}
                medium_columns={gridConstants.column.SIX}
                large_columns={gridConstants.column.SIX}
                label={`Student`}
                options={students}
            />
            <GridCell large_offset={gridConstants.column.THREE} medium_columns={gridConstants.column.SIX}
                      large_columns={gridConstants.column.THREE}>
                <LinkButton {...locations.SHIPPING_LOCATION_ADD.link} isExpanded/>
            </GridCell>
            <GridCell medium_columns={gridConstants.column.SIX} large_columns={gridConstants.column.SIX}>
                <Button
                    isPrimary
                    label={`Submit`}
                    name={`btnSubmit`}
                    onClick={handleClickSubmit}
                />
            </GridCell>
        </GridContainer>
        <br/>
        <br/>
    </>;
};
